const modifyScriptName = (tradingsymbol, expiry = null, item = {}) => {
  // Extract the base symbol (everything except the last 8 characters)
  const baseSymbol = tradingsymbol.slice(0, -8);

  // Extract the month abbreviation (3 characters before 'FUT')
  const monthAbbr = tradingsymbol.slice(-6, -3);

  // Convert month abbreviation to proper case
  const formattedMonth = monthAbbr.charAt(0).toUpperCase() + monthAbbr.slice(1).toLowerCase();

  // If expiry is provided, extract the day
  if (expiry) {
    try {
      const expiryDate = new Date(expiry);
      const day = expiryDate.getDate().toString().padStart(2, '0');
      return `${baseSymbol} ${day} ${formattedMonth}`;
    } catch (error) {
      console.warn('Invalid expiry date provided, falling back to default format:', error);
      // Fall back to default format if expiry is invalid
      return `${baseSymbol} ${formattedMonth}`;
    }
  }

  // Default format without expiry (backward compatibility)
  return `${baseSymbol} ${formattedMonth}`;
};

export const calculateActiveProfitLoss = (activeTrades, priceConfig) => {
  try {
    // Initialize overall profit or loss
    let overallProfitLoss = 0;
    let blockedMargin = 0;
    // console.log('ACTIVE TRADE', activeTrades);

    // Iterate through each active trade
    activeTrades.forEach((trade) => {
      let multiplicationFactor = 1;
      // Get the buy price and sell price based on the side of the trade
      if (trade.script.exchange.name === 'MCX' || trade.script.exchange.name === 'COMEX') {
        const scriptName = trade.script.name;
        const factor = priceConfig[trade.script.exchange.name][scriptName] || 1;
        multiplicationFactor = factor;
      }
      const price = trade.side === 'BUY' ? trade.script?.depth?.buy[0].price : trade.script?.depth?.sell[0].price;
      // Calculate profit or loss for the trade
      const tradeProfitLoss =
        trade.side === 'BUY'
          ? (price - trade.buy) * multiplicationFactor * trade.quantity
          : (trade.sell - price) * multiplicationFactor * trade.quantity;
      // console.log(tradeProfitLoss);
      // Add the trade profit or loss to the overall profit or loss
      overallProfitLoss += tradeProfitLoss;
      blockedMargin += trade.margin;
    });
    return { overallProfitLoss, blockedMargin };
  } catch (error) {
    console.error('Error calculating overall profit or loss:', error);
    throw error;
  }
};

export default modifyScriptName;
